import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { YtgService } from "@modules/ytg/api/ytg.service";
import type { Language } from "@shared-types";

/** Return shape of {@link useYtgLangs}. */
export interface UseYtgLangsReturn {
    languages: Language[];
    loading: boolean;
    error: Error | null;
    /** Re-run the languages query. */
    refetch: UseQueryResult<Language[]>["refetch"];
}

/**
 * Query hook returning the list of supported YTG languages.
 *
 * @example
 * ```tsx
 * const { languages, loading } = useYtgLangs();
 * ```
 */
export const useYtgLangs = (): UseYtgLangsReturn => {
    const { data, isLoading, error, refetch } = useQuery<Language[]>({
        queryKey: ["ytg", "langs"],
        queryFn: ({ signal }) => YtgService.getLanguages({ signal }),
    });
    return { languages: data ?? [], loading: isLoading, error, refetch };
};
